// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("./IconV5.bs.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let TailwindVariants = require("../../bindings/TailwindVariants.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TailwindVariants$1 = require("tailwind-variants");
let ReactAriaComponents = require("react-aria-components");

let overlayStyles = TailwindVariants$1.tv({
  base: "fixed top-0 left-0 w-full h-full isolate z-50 bg-[#1b3549]/50 flex items-start justify-center px-4 pt-20 pb-10 sm:pt-24 sm:pb-16 backdrop-blur-sm overscroll-contain overflow-y-auto",
  variants: {
    isEntering: {
      true: "animate-in fade-in duration-200 ease-out"
    },
    isExiting: {
      true: "animate-out fade-out duration-200 ease-in"
    },
    size: {
      PagePreview: "pt-24 sm:pt-28",
      FullScreen: "bg-white px-0 pt-0 pb-0 sm:pt-0 sm:pb-0"
    }
  }
});

let modalStyles = TailwindVariants$1.tv({
  base: "w-full rounded-md bg-white forced-colors:bg-[Canvas] text-left align-middle text-slate-700 shadow-md bg-clip-padding",
  variants: {
    isEntering: {
      true: "animate-in zoom-in-105 ease-out duration-200"
    },
    isExiting: {
      true: "animate-out zoom-out-95 ease-in duration-200"
    },
    size: {
      Small: "max-w-[320px] sm:max-w-[340px]",
      Default: "max-w-[400px]",
      Large: "max-w-[500px]",
      XLarge: "max-w-[600px]",
      XXLarge: "max-w-[680px]",
      LgWide: "sm:max-w-[560px] md:max-w-[580px]",
      XlWide: "sm:max-w-[600px] md:max-w-[700px]",
      PagePreview: "max-w-[calc(100vw-2rem)] overflow-hidden sm:max-w-[calc(100vw-2rem)] md:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1180px]",
      FullScreen: "max-w-none h-full m-0 rounded-none shadow-none"
    }
  }
});

function DialogV5$TitleSection(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("h2", {
      children: props.children,
      className: "text-white text-3xl font-medium"
    }),
    className: "flex flex-col justify-center content-center w-full mb-2 p-4 text-center bg-tan-blue-500 sm:rounded-t-md"
  });
}

function DialogV5$UnstyledContent(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "flex flex-col p-4 relative"
  });
}

let UnstyledContent = {
  make: DialogV5$UnstyledContent
};

function DialogV5$Content(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "box-border flex flex-col justify-center content-center w-full sm:rounded-md"
  });
}

let Content = {
  make: DialogV5$Content
};

function DialogV5$StickyFooter(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: TailwindMerge.twMerge([
      "sticky bottom-0 z-10 p-4 bg-gray-50 border-t border-zinc-200 -mx-4 -mb-4",
      className
    ])
  });
}

let StickyFooter = {
  make: DialogV5$StickyFooter
};

function DialogV5$ActionBar(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx(DialogV5$StickyFooter, {
    children: props.children,
    className: TailwindMerge.twMerge([
      "flex [&>button]:flex-grow",
      className
    ])
  });
}

let ActionBar = {
  make: DialogV5$ActionBar
};

function DialogV5(props) {
  let children = props.children;
  let transitionOnDestroyed = props.transitionOnDestroyed;
  let __modalClassName = props.modalClassName;
  let __overlayClassName = props.overlayClassName;
  let __showCloseButton = props.showCloseButton;
  let __size = props.size;
  let __customContent = props.customContent;
  let onDismiss = props.onDismiss;
  let isOpen = props.isOpen;
  let title = props.title;
  let customContent = __customContent !== undefined ? __customContent : false;
  let size = __size !== undefined ? __size : "Default";
  let showCloseButton = __showCloseButton !== undefined ? __showCloseButton : true;
  let overlayClassName = __overlayClassName !== undefined ? __overlayClassName : "";
  let modalClassName = __modalClassName !== undefined ? __modalClassName : "";
  let timeoutRef = React.useRef(undefined);
  React.useEffect(() => {
    if (!isOpen && transitionOnDestroyed !== undefined) {
      let id = timeoutRef.current;
      if (id !== undefined) {
        clearTimeout(Primitive_option.valFromOption(id));
      }
      let id$1 = setTimeout(() => transitionOnDestroyed(), 220);
      timeoutRef.current = Primitive_option.some(id$1);
      return () => {
        let id = timeoutRef.current;
        if (id !== undefined) {
          clearTimeout(Primitive_option.valFromOption(id));
        }
        timeoutRef.current = undefined;
      };
    }
    let id$2 = timeoutRef.current;
    if (id$2 !== undefined) {
      clearTimeout(Primitive_option.valFromOption(id$2));
    }
    timeoutRef.current = undefined;
  }, [
    isOpen,
    transitionOnDestroyed
  ]);
  return JsxRuntime.jsxs(ReactAriaComponents.ModalOverlay, {
    children: [
      showCloseButton ? JsxRuntime.jsx(ReactAriaComponents.Button, {
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "cancel",
            size: 24,
            className: "text-white"
          }),
          slot: "close",
          className: v => TailwindMerge.twMerge([
            "fixed top-0 right-0 p-[20px] cursor-pointer focus:outline-none rounded",
            TailwindVariants.Utils.focusRing({
              isFocusVisible: v.isFocusVisible
            })
          ]),
          onClick: param => onDismiss()
        }) : null,
      JsxRuntime.jsx(ReactAriaComponents.Modal, {
        children: JsxRuntime.jsx(ReactAriaComponents.Dialog, {
          children: customContent ? children : JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                title !== undefined ? JsxRuntime.jsx(ReactAriaComponents.Heading, {
                    children: JsxRuntime.jsx(DialogV5$TitleSection, {
                      children: title
                    }),
                    slot: "title"
                  }) : null,
                JsxRuntime.jsx(DialogV5$UnstyledContent, {
                  children: children
                })
              ]
            }),
          ariaLabel: props.ariaLabel
        }),
        className: v => TailwindMerge.twMerge([
          modalStyles({
            isEntering: v.isEntering,
            isExiting: v.isExiting,
            state: v.state,
            size: size
          }),
          modalClassName
        ]),
        isDismissable: true
      })
    ],
    isDismissable: true,
    className: v => TailwindMerge.twMerge([
      overlayStyles({
        isEntering: v.isEntering,
        isExiting: v.isExiting,
        state: v.state,
        size: size
      }),
      overlayClassName
    ]),
    isOpen: isOpen,
    onOpenChange: newOpen => {
      if (!newOpen) {
        return onDismiss();
      }
    }
  });
}

let make = DialogV5;

exports.UnstyledContent = UnstyledContent;
exports.Content = Content;
exports.StickyFooter = StickyFooter;
exports.ActionBar = ActionBar;
exports.make = make;
/* overlayStyles Not a pure module */
